import React, { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Loading from "../../components/Loading";
import Paper from '@mui/material/Paper';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { CardActions, useTheme } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import api from '../../services/api';
import icon from '../../image/atendimentoIconGreen.png'
import LoadingButton from '@mui/lab/LoadingButton';

import {BiMessageRoundedCheck, BiMessageRoundedError} from 'react-icons/bi';
import Detalhes from './components/Detalhes';
import { getToken } from '../../services/auth';
import {logNavegacao} from '../../function'
import HeaderBody from '../../components/HeaderBody';

function Atendimentos({setShowAtendimentos, user}) {
    const theme = useTheme();
    let initialized = false
    let idContrato = user.idContrato;
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState([]);
    const [detalhes, setdetalhes] = useState(0);
    useEffect(() => {
        setPage(1);
        const getPayments = async (contrato) => {
            setLoading(true)
            let token = await getToken();
            api.get(`/clients/attendance`,{
                params: {
                    token,
                    page: 0,
                    contrato,
                    limit: 10,
                }
            }).then(function (response) {
                let {data, status} = response.data;
                if(status === true){
                    if(data != null){
                        setList(data)
                    }else{
                        setList([])
                    }
                }
                setLoading(false)
                 // eslint-disable-next-line react-hooks/exhaustive-deps
                 initialized = false;
            }).catch(function(error){
                console.log(error)
                setLoading(false)
                 // eslint-disable-next-line react-hooks/exhaustive-deps
                 initialized = false;
            });
        }
        if(idContrato !== 0 && idContrato != null && idContrato !== undefined){
            if (!initialized) {
                initialized = true;
                getPayments(idContrato);
            }
        }
    }, [idContrato]);
    const [ page, setPage ] = useState(1);
    const [loadingBt, setLoadingBt] = useState(false);
    const loadMore = async (contrato) => {
        setLoadingBt(true)
        let token = await getToken();
        api.get(`/clients/attendance`,{
            params: {
                token,
                page,
                contrato,
                limit: 10,
            }
        }).then(function (response) {
            let {data, status} = response.data;
            if(status === true){
                if(data != null){
                    setList(oldList => [...oldList, ...data]);
                }
            }
            setLoadingBt(false)
            setPage(page + 1);
        }).catch(function(error){
            console.log(error)
            setLoadingBt(false)
        });
    }
    const [height, setWidth] = useState(0);
    useEffect(() => {
        const element = document.getElementById('home');
        if (element) {
          setWidth(element.getBoundingClientRect().height - 260); // or height
        }
    }, []);
    const renderFaturas = (element, idx) => {
        let {id, data, status, motivo, hora, protocolo, datasolucao, horaSolucao} = element;
        return (
            <div key={idx} className="col-sm-12 col-xs-12 col-12 col-md-12 col-lg-12 col-xl-12" style={{marginBottom: 20, marginTop: 20}}>
                <Paper elevation={12} onClick={() => {
                    setdetalhes(id);
                    logNavegacao('Navegacao', `Detalhes atendimento atendimentId: ${id}`);
                    }}
                    style={{cursor: "pointer"}}>
                    <CardContent>
                        <Stack direction="row" spacing={2}>
                            {status === "OK" ? (
                                <Avatar sx={{ backgroundColor: 'var(--main-bg-color)', width: 50, height: 50 }} >
                                    <BiMessageRoundedCheck color={"var(--main-white-color)"} size={30} />
                                </Avatar>
                            ) : (
                                <Avatar sx={{ backgroundColor: 'transparent', width: 50, height: 50 }} >
                                    <BiMessageRoundedError color={"#a3a3a3"} size={30} />
                                </Avatar>
                            )}
                            <Stack direction="column" spacing={0}>
                                <Typography gutterBottom variant="body2" component="div">
                                    Protocolo: {protocolo}
                                </Typography>
                                <Typography gutterBottom variant="body2" component="div">
                                    Status: {status}
                                </Typography>
                            </Stack>
                        </Stack>
                        <Typography variant="body2" style={{marginTop: 10}}>
                            Motivo: {motivo}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Abertura: {data} {hora}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Fechamento: {datasolucao} {horaSolucao}
                        </Typography>
                    </CardContent>
                </Paper>
            </div>
        );
    }
    return (
        <Card style={{margin: 20}} className={theme.palette.mode === "dark" ? "bg-dark text-white" : null}>
            <Loading open={loading} />
            <Card.Header>
                <HeaderBody title={"Solicitações de atendimento"} icon={icon} setShow={setShowAtendimentos} />
            </Card.Header>
            <Card.Body className='row' style={{paddingTop: 0, paddingBottom: 0}}>
                <div style={{overflow: "auto", height: height}}>
                    {detalhes === 0 ? (
                        <>
                            {list.map((elemeto, index) => (
                                renderFaturas(elemeto, index)
                            ))}
                            {list.length > 0 && (
                                <div className="col-sm-12 col-xs-12 col-12 col-md-12 col-lg-12 col-xl-12" >
                                    <CardActions style={{justifyContent: 'space-around', paddingBottom: 16}}>
                                        <LoadingButton 
                                        variant="secondary" 
                                        loading={loadingBt} 
                                        onClick={() => loadMore(idContrato)}
                                        >
                                            Mostrar mais...
                                        </LoadingButton>
                                    </CardActions>
                                </div>
                            )}
                        </>
                    ) : (
                        <Detalhes setdetalhes={setdetalhes} idAtendimento={detalhes} />
                    )}
                </div>
            </Card.Body>
        </Card>
    );
}

export default Atendimentos;